import {Status} from '@/types/offers'
import {addDaysToDate, isPastToday, isValidDate} from '@/utils/date-helper'

export const OFFER_EXPIRE_DAYS = 30

export function isExpiredOffer(offer: any) {
  if (offer.status !== Status.Accepted && offer.status !== Status.Pending) {
    return false
  }

  const activityDate = offer.lastActivityAt ?? offer.updatedAt

  if (!isValidDate(activityDate)) {
    return false
  }

  // is expired after 30 days of the last activity date
  const date = addDaysToDate(activityDate, OFFER_EXPIRE_DAYS)

  return date ? isPastToday(date) : false
}
